import styled from "styled-components"

export const LabelWrapper = styled.label `
    display: block;
`